import { NumberInput as NumberInputComponent, TextInput as TextInputComponent } from '@ztechapps/webui.input'
import { MetadataValueSelect as MetadataValueSelectComponent } from './MetadataValueSelect'
import { useAppSetting } from '@ztechapps/common.hook'
import React from 'react'
import { jsonTryParse } from '@ztechapps/common.utils'
import { AppSettingKey } from '@ztechapps/product.common'
import type { MetadataRecord } from './MetadataSchema'

const schemaInputFactory = {
  run: (inputName) => {
    return schemaInputFactory[inputName] ?? TextInputComponent
  },
  NumberInput: NumberInputComponent,
  MetadataValueSelect: MetadataValueSelectComponent,
  TextInput: TextInputComponent,
  LengthInput: NumberInputComponent,
  WeightInput: NumberInputComponent,
  AngleInput: NumberInputComponent,
}

export type UseProductMetadataProps = {
  appSettingKey?: string
}

export type UseProductMetadataResult = {
  metadataSchema: MetadataRecord
  publicMetadataSchema: MetadataRecord
}

export const useProductMetadata = ({
  appSettingKey = AppSettingKey.PRODUCT_SPECIFICATIONS,
}: UseProductMetadataProps = {}): UseProductMetadataResult => {
  const { setting, loading } = useAppSetting({ appSettingKey })
  const [metadataSchema, setMetadataSchema] = React.useState<MetadataRecord>()
  const [publicMetadataSchema, setPublicMetadataSchema] = React.useState<MetadataRecord>()
  React.useEffect(() => {
    if (setting?.value) {
      const formattedSetting = jsonTryParse(setting?.value)

      const allMetadataValues: any = {},
        publicValues: any = {}
      const list: [string, any][] = Object.entries(formattedSetting)
      for (const [key, value] of list) {
        const input = schemaInputFactory.run(value?.input)
        allMetadataValues[key] = { ...value, input, inputName: value?.input }

        if (value?.isPublic) {
          publicValues[key] = { ...value, input }
        }
      }
      setMetadataSchema(allMetadataValues)

      setPublicMetadataSchema(publicValues)
    }
  }, [setting, loading])

  return { metadataSchema, publicMetadataSchema }
}
